import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Bell, Info, Menu } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { toast } from "sonner";
// import { useNotifications } from "@/contexts/NotificationContext";
import api from "@/lib/api";

const pageTitles = {
  "/dashboard": "nav.dashboard",
  "/bookings": "nav.bookings",
  "/reviews": "nav.reviews",
  "/profile": "nav.profile",
  "/finance": "nav.payments",
  "/settings": "nav.settings",
  // "/notifications": "nav.notifications",
  "/help": "nav.help",
};

export default function Header({ onMenuClick, inactive, setInactive }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  // const { unreadCount } = useNotifications();
  const unreadCount = 0; // Disabled notifications
  
  const titleKey = pageTitles[location.pathname] || "nav.dashboard";

  const handleToggle = async (checked) => {
    setInactive(checked);
    try {
      await api.post("/rahe-portal/account/mark-inactive", { inactive: checked });
      toast.info(
        checked
          ? t("header.stopReceiving")
          : t("header.markInactive").replace("Mark me inactive", "You are now active")
      );
    } catch {
      toast.error("Failed to update status");
      setInactive(!checked);
    }
  };

  return (
    <header
      className="fixed top-0 left-0 lg:left-64 right-0 h-16 bg-white border-b border-slate-200/80 shadow-sm flex items-center justify-between px-4 sm:px-6 lg:px-8 z-40"
      data-testid="main-header"
    >
      <div className="flex items-center gap-3">
        <button
          className="lg:hidden p-2 rounded-lg hover:bg-slate-100 transition-colors"
          onClick={onMenuClick}
          data-testid="mobile-menu-btn"
        >
          <Menu className="w-5 h-5 text-slate-600" />
        </button>
        <h1
          className="text-lg font-semibold text-slate-900"
          style={{ fontFamily: "Manrope, sans-serif" }}
        >
          {t(titleKey)}
        </h1>
      </div>

      <div className="flex items-center gap-4 sm:gap-6">
        <div className="hidden sm:flex items-center gap-2.5">
          <span className="text-sm text-slate-500">{t("header.markInactive")}</span>
          <Switch
            checked={inactive}
            onCheckedChange={handleToggle}
            data-testid="inactive-toggle"
          />
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Info className="w-4 h-4 text-slate-400 cursor-help" />
              </TooltipTrigger>
              <TooltipContent>
                <p className="text-xs">{t("header.stopReceiving")}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>

        <button
          className="relative p-2 rounded-lg hover:bg-slate-100 transition-colors opacity-50 cursor-not-allowed"
          data-testid="notifications-btn"
          disabled
          // onClick={() => navigate("/notifications")}
        >
          <Bell className="w-5 h-5 text-slate-500" />
          {/* {unreadCount > 0 && (
            <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center px-1 animate-scaleIn">
              {unreadCount > 9 ? "9+" : unreadCount}
            </span>
          )} */}
        </button>
      </div>
    </header>
  );
}
